import React from "react";
import "./VetsOverview.css";

const VetsOverview = () => {
  const cardsData = [
    {
      title: "Consultations (7d)",
      value: "1,885",
      subtitle: "8 active vets",
    },
    {
      title: "Vets by primary specialty",
      value: "4 groups",
      subtitle: "Surgery 3 · General Medicine 3 · other 2",
    },
    {
      title: "Avg utilization (7d)",
      value: "76%",
      subtitle: "booked vs available slots",
    },
    {
      title: "Upcoming appointments",
      value: "6",
      subtitle: "next 7 days",
    },
  ];

  return (
    <div className="vets-overview-container mv10">
      <h2 className="vets-overview-title">Vets overview</h2>
      <div className="vets-overview-cards-grid">
        {cardsData.map((card, index) => (
          <div className="vets-overview-card" key={index}>
            <div className="vets-overview-card-title">{card.title}</div>
            <div className="vets-overview-card-value">{card.value}</div>
            <div className="vets-overview-card-subtitle">{card.subtitle}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VetsOverview;
